import PropTypes from 'prop-types';
import React from 'react';

const ActiveFilterBadges = ({
  activeFilters,
  filterGroups,
  onRemoveFilter,
  onClearAll,
  onOpenFilterSidebar
}) => {
  const getFilterById = (filterId) => {
    for (const group of filterGroups) {
      const filter = group.filters.find(f => f.id === filterId);
      if (filter) {
        return filter;
      }
    }
    return null;
  };

  const getActiveFilterCount = () => {
    return Object.values(activeFilters).reduce((count, values) => {
      if (Array.isArray(values) && values.length > 0) {
        return count + 1;
      }
      if (typeof values === 'object' && values !== null && !Array.isArray(values)) {
        const hasValue = Object.values(values).some(v => v !== '' && v !== null && v !== undefined);
        if (hasValue) {
          return count + 1;
        }
      }
      return count;
    }, 0);
  };

  const renderFilterBadges = () => {
    return Object.entries(activeFilters).map(([filterId, values]) => {
      if (!values) return null;
      if (typeof values === 'string' && values.trim().length === 0) return null;
      if (Array.isArray(values) && values.length === 0) return null;
      if (typeof values === 'object' && !Array.isArray(values)) {
        if (values.min === '' && values.max === '') return null;
        if (values.start === '' && values.end === '') return null;
      }

      const filter = getFilterById(filterId);
      if (!filter) return null;

      let displayText = filter.label;
      if (filter.type === 'range') {
        const parts = [];
        if (values.min) parts.push(`Min: ${values.min}`);
        if (values.max) parts.push(`Max: ${values.max}`);
        displayText = parts.length > 0 ? `${filter.label}: ${parts.join(', ')}` : filter.label;
      } else if (filter.type === 'date_range') {
        const parts = [];
        if (values.start) parts.push(`From: ${values.start}`);
        if (values.end) parts.push(`To: ${values.end}`);
        displayText = parts.length > 0 ? `${filter.label}: ${parts.join(', ')}` : filter.label;
      } else if (typeof values === 'string') {
        displayText = `${filter.label}: ${values}`;
      } else if (Array.isArray(values) && filter.options) {
        const labels = values.map(v => {
          const opt = filter.options.find(o => o.value === v);
          return opt ? opt.label : v;
        });
        displayText = `${filter.label}: ${labels.join(', ')}`;
      } else {
        displayText = `${filter.label} (${values.length})`;
      }

      return (
        <div
          key={filterId}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '8px 12px',
            backgroundColor: 'var(--od-c-ffffff, #ffffff)',
            border: '1px solid var(--od-c-d5d7da, #d5d7da)',
            borderRadius: '8px',
            fontFamily: "'Open Sans', sans-serif",
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            color: 'var(--od-c-1982c4, #1982c4)',
            cursor: 'pointer'
          }}
        >
          <button
            onClick={(e) => {
              e.stopPropagation();
              onRemoveFilter(filterId);
            }}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              display: 'flex',
              alignItems: 'center',
              color: 'var(--od-c-1982c4, #1982c4)'
            }}
          >
            <i className="fal fa-times" style={{ fontSize: '14px' }}></i>
          </button>
          <span style={{ whiteSpace: 'nowrap' }}>
            {displayText}
          </span>
        </div>
      );
    });
  };

  return (
    <div className="d-flex align-items-center flex-wrap" style={{ gap: '12px' }}>
      {renderFilterBadges()}

      <button
        onClick={onOpenFilterSidebar}
        className="btn btn-setlist-secondary"
      >
        <i className="fal fa-plus" style={{ fontSize: '20px' }}></i>
        <span style={{ padding: '0 2px' }}>Add filter</span>
      </button>

      {getActiveFilterCount() > 0 && (
        <button
          onClick={onClearAll}
          className="btn btn-setlist-secondary"
        >
          <span style={{ padding: '0 2px' }}>Clear</span>
        </button>
      )}
    </div>
  );
};

ActiveFilterBadges.propTypes = {
  activeFilters: PropTypes.object.isRequired,
  filterGroups: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    filters: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      type: PropTypes.string
    }))
  })).isRequired,
  onRemoveFilter: PropTypes.func.isRequired,
  onClearAll: PropTypes.func.isRequired,
  onOpenFilterSidebar: PropTypes.func.isRequired
};

export default ActiveFilterBadges;
